<div class="not-authorized">
  <h1>403 - Not Authorized</h1>
  <p>You do not have permission to access this page.</p>
  <button (click)="logout()">Logout</button>
</div>